/**
 * Mismo patrón que terapia (Core.js / cita.js / Login.js):
 * - URL base del backend PHP desplegado
 * - headers Content-Type: text/html en todas las peticiones POST
 */
const defaultBase =
  "https://institutobilinguelasnaciones.com/terapias/backend";

export const terapiasBackendBase =
  typeof process !== "undefined" &&
  process.env &&
  process.env.REACT_APP_TERAPIAS_BACKEND_BASE
    ? String(process.env.REACT_APP_TERAPIAS_BACKEND_BASE).replace(/\/$/, "")
    : defaultBase;

export const axiosTerapiaConfig = {
  headers: { "Content-Type": "text/html" },
};

/**
 * Secreto compartido con accesoCamaraTerapia_config.php (vistaTerapiaAppSecret).
 * 1) Preferir REACT_APP_VISTA_TERAPIA_SECRET en .env.development.local / .env.production
 * 2) Si vacío, usar fallback (mismo criterio que Login.js con tok en código)
 */
const VISTA_TERAPIA_SECRET_FALLBACK = "";

export function getVistaTerapiaSecret() {
  const fromEnv =
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_VISTA_TERAPIA_SECRET
      ? String(process.env.REACT_APP_VISTA_TERAPIA_SECRET).trim()
      : "";
  if (fromEnv) return fromEnv;
  return String(VISTA_TERAPIA_SECRET_FALLBACK || "").trim();
}

